export const gatherBrowserInfo =  async () => {
    const ua = navigator.userAgent || "";
    function detectBrowser() {
      if (navigator.userAgentData && navigator.userAgentData.brands) {
        const brands = navigator.userAgentData.brands;
        const primary = brands.find(b => !/Not|Chromium|Google/.test(b.brand));
        if (primary) return { name: primary.brand, version: primary.version };
      }
      let name = "Unknown", version = "";
      if (/Edg\//.test(ua)) {
        name = "Microsoft Edge";
        version = ua.match(/Edg\/([\d.]+)/)?.[1] || "";
      } else if (/OPR\//.test(ua)) {
        name = "Opera";
        version = ua.match(/OPR\/([\d.]+)/)?.[1] || "";
      } else if (/Chrome\//.test(ua)) {
        name = "Google Chrome";
        version = ua.match(/Chrome\/([\d.]+)/)?.[1] || "";
      } else if (/Safari\//.test(ua) && !/Chrome|Chromium|Edg\//.test(ua)) {
        name = "Safari";
        version = ua.match(/Version\/([\d.]+)/)?.[1] || "";
      } else if (/Firefox\//.test(ua)) {
        name = "Mozilla Firefox";
        version = ua.match(/Firefox\/([\d.]+)/)?.[1] || "";
      } else if (/MSIE|Trident\//.test(ua)) {
        name = "Internet Explorer";
        version = ua.match(/(MSIE |rv:)([\d.]+)/)?.[2] || "";
      }
      return { name, version };
    }
    
    const { name: browserName, version: browserVersion } = detectBrowser();
    const info = {
      browserName,
      browserVersion,
      platform: navigator.platform || null,
      
    };
    return info;
  }